import { LOCALE } from '../util/locale';

// See: https://en.wikipedia.org/wiki/ISO_4217

export const SUPPORTED_CURRENCY = {
  BRAZIL_REAL: 'BRL',
  POLAND_ZLOTY: 'PLN',
  S_AFRICA_RAND: 'ZAR',
  US_DOLLAR: 'USD',
  NOK: 'NOK',
  SEK: 'SEK',
};

// See: https://stripe.com/docs/currencies
export const subUnitDivisors = {
  AUD: 100,
  CAD: 100,
  CHF: 100,
  CNY: 100,
  DKK: 100,
  EUR: 100,
  GBP: 100,
  HKD: 100,
  INR: 100,
  JPY: 1,
  MXN: 100,
  NOK: 100,
  NZD: 100,
  SEK: 100,
  SGD: 100,
  USD: 100,

  // Some of these are not in Stripe,
  // but we don't use Stripe either way.
  [SUPPORTED_CURRENCY.POLAND_ZLOTY]: 100,
  [SUPPORTED_CURRENCY.BRAZIL_REAL]: 100,
  [SUPPORTED_CURRENCY.S_AFRICA_RAND]: 100,
};

export const SUPPORTED_CURRENCIES = Object.values(SUPPORTED_CURRENCY);

export const CURRENCY_BY_LOCALE = {
  [LOCALE.POLAND]: SUPPORTED_CURRENCY.POLAND_ZLOTY,
  [LOCALE.BRAZIL]: SUPPORTED_CURRENCY.BRAZIL_REAL,
  [LOCALE.SOUTH_AFRICA]: SUPPORTED_CURRENCY.S_AFRICA_RAND,
  [LOCALE.UNITED_STATES]: SUPPORTED_CURRENCY.US_DOLLAR,
  [LOCALE.NORWAY]: SUPPORTED_CURRENCY.NOK,
  [LOCALE.SWEDEN]: SUPPORTED_CURRENCY.SEK,
};

/**
 * Currency formatting options.
 * See: https://github.com/yahoo/react-intl/wiki/API#formatnumber
 *
 * @param {string} currency
 */
export const currencyFormatting = currency => {
  if (!subUnitDivisors[currency]) {
    const currencies = Object.keys(subUnitDivisors);
    throw new Error(
      `Configuration missing for currency: ${currency}. Supported currencies: ${currencies.join(
        ', '
      )}.`
    );
  }

  return subUnitDivisors[currency] === 1
    ? {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        useGrouping: true,
        // If the currency is not using subunits (like JPY), remove fractions.
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    : {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
};
